(() => {
  'use strict';
  const scene=document.querySelector('.tm-magnetic-journey');
  if(!scene || scene.dataset.tmReady) return;
  scene.dataset.tmReady='1';
  const abort=new AbortController(),signal=abort.signal;
  const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal});
  const stage=scene.querySelector('.tm-journey-stage');
  const dock=document.querySelector('.tm-purchase-dock');
  const flight=document.querySelector('.tm-product-flight');
  if(!dock || !flight) return;
  const flightImage=flight.querySelector('img');
  const bottleFlight=document.querySelector('.tm-bottle-flight');
  const bottleImage=bottleFlight.querySelector('img');
  document.body.append(flight,bottleFlight);
  const clip=document.querySelector('.tm-product-clip-defs');
  if(clip)document.body.append(clip);
  const dockBag=dock.querySelector(':scope > img');
  const dockBottle=dock.querySelector('.tm-dock-bottle');
  const word=scene.querySelector('.tm-journey-word');
  const halo=scene.querySelector('.tm-journey-halo');
  const shadow=flight.querySelector('.tm-flight-shadow');
  const chapters=[...scene.querySelectorAll('.tm-journey-chapter')];
  const markers=[...scene.querySelectorAll('.tm-journey-progress i')];
  const chapterNumber=scene.querySelector('[data-chapter-number]');
  const light=scene.querySelector('.tm-journey-light');
  const floor=scene.querySelector('.tm-journey-floor');
  const toggle=scene.querySelector('.tm-motion-switch');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const lerp=(a,b,t)=>a+(b-a)*t;
  const smooth=t=>t*t*(3-2*t);
  let manualPause=false, geometry=null, frame=0, chapter=-1, currentColor='Preto';
  let effect=null;
  function disabled(){return reduced.matches||manualPause;}
  function measure(){
    const width=document.documentElement.clientWidth;
    const narrow=width<=800, header=document.querySelector('.tm-site-chrome')?.offsetHeight || 99;
    // Freeze the stage height for mobile toolbar changes, just like the hero.
    if(!geometry||geometry.width!==width) scene.style.setProperty('--journey-height',Math.max(320,innerHeight-header)+'px');
    scene.style.setProperty('--tm-header',header+'px');
    const sr=scene.getBoundingClientRect(),dr=dockBag.getBoundingClientRect(),br=dockBottle.getBoundingClientRect();
    const height=stage.offsetHeight;
    geometry={width,narrow,header,height,top:sr.top+scrollY,travel:Math.max(1,scene.offsetHeight-height),dockX:dr.left+dr.width/2,dockY:dr.top+scrollY+dr.height/2,dockSize:dockBag.offsetWidth,bottleDockX:br.left+br.width/2,bottleDockY:br.top+scrollY+br.height/2,bottleDockSize:dockBottle.offsetWidth};
    schedule();
  }
  function setChapter(value){
    if(chapter===value)return;chapter=value;
    chapters.forEach((el,i)=>{el.classList.toggle('is-current',i===value);el.setAttribute('aria-hidden',disabled()?'false':String(i!==value));});
    markers.forEach((el,i)=>el.classList.toggle('active',i===value));
    chapterNumber.textContent='0'+(value+1);
    word.textContent=['TAKEBAG.','DETALHES.','HIDRATE.','JUNTOS.'][value];
  }
  function update(){
    frame=0;if(!geometry||disabled()||document.hidden){flight.style.opacity='0';bottleFlight.style.opacity='0';return;}
    const g=geometry,y=scrollY,start=g.top-g.header,end=start+g.travel;
    const progress=clamp((y-start)/g.travel);
    const poses=window.TakeBagOfficialJourney.pose(progress,g.width,g.height,g.narrow);
    const bag=poses.bag,bottle=poses.bottle;
    const localTop=Math.max(g.top-y,g.header);
    bag.y+=localTop;bottle.y+=localTop;
    setChapter(poses.chapter);
    const ending=Math.max(80,Math.max(g.dockY,g.bottleDockY)-end-g.header-95);
    const exit=smooth(clamp((y-end)/ending));
    if(y>end){
      bag.x=lerp(bag.x,g.dockX,exit);bag.y=lerp(bag.y,g.dockY-y,exit)+Math.sin(exit*Math.PI)*18;
      bag.size=lerp(bag.size,g.dockSize,exit);bag.angle=lerp(bag.angle,-3,exit);
      bottle.x=lerp(bottle.x,g.bottleDockX,exit);bottle.y=lerp(bottle.y,g.bottleDockY-y,exit)+Math.sin(exit*Math.PI)*24;
      bottle.size=lerp(bottle.size,g.bottleDockSize,exit);bottle.angle=lerp(bottle.angle,3,exit);
    }
    const visible=(g.top-y<innerHeight*.83)&&(exit<.999)&&(y<g.dockY+200);
    dock.classList.toggle('is-in-flight',visible);
    flight.classList.toggle('is-visible',visible);
    bottleFlight.classList.toggle('is-visible',visible&&bottle.opacity>0);
    flight.style.opacity=visible?String(bag.opacity):'0';
    bottleFlight.style.opacity=visible?String(bottle.opacity):'0';
    if(visible){
      flight.style.transform=`translate3d(${bag.x-220}px,${bag.y-220}px,0) scale(${bag.size/440}) rotate(${bag.angle}deg)`;
      bottleFlight.style.transform=`translate3d(${bottle.x-220}px,${bottle.y-220}px,0) scale(${bottle.size/440}) rotate(${bottle.angle}deg)`;
      shadow.style.transform=`translateY(${Math.sin(progress*Math.PI*3)*-1.7}px) scaleX(${.9+Math.cos(progress*Math.PI*3)*.1})`;
      light.style.transform=`translate(-50%,-50%) translateX(${(bag.x-g.width*.5)*.45}px)`;
      halo.style.opacity=String(.25+poses.join*.4+poses.detail*.25);
      halo.style.transform=`translate(-50%,-50%) scale(${1+poses.join*.25}) rotate(${progress*25}deg)`;
      floor.style.transform=`translate(-50%,-50%) translateX(${g.narrow?0:(bag.x-g.width*.7)}px) scaleX(${1+poses.join*.5})`;
    }
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  function applyPreference(){
    const isDisabled=disabled();
    document.body.classList.toggle('tm-motion-enhanced',!isDisabled);
    document.body.classList.toggle('tm-motion-disabled',isDisabled);
    toggle.setAttribute('aria-pressed',String(isDisabled));
    toggle.querySelector('span').textContent=isDisabled?'Ativar efeitos':'Pausar efeitos';
    if(isDisabled){effect?.cancel();dock.classList.remove('is-in-flight');chapters.forEach(el=>el.setAttribute('aria-hidden','false'));}
    chapter=-1;setChapter(0);measure();
  }
  on(toggle,'click',()=>{manualPause=!manualPause;applyPreference();});
  on(reduced,'change',applyPreference);
  function color(value){
    currentColor=value;
    const url=value==='Rosa'?scene.dataset.bagPink:scene.dataset.bagBlack;
    flightImage.src=url;dockBag.src=url;scene.querySelector('.tm-journey-static-bag').src=url;
    scene.querySelector('.tm-journey-static-bag').alt='TakeBag magnética '+(value==='Rosa'?'rosa':'preta');
    const bottleUrl=value==='Rosa'?scene.dataset.bottlePink:scene.dataset.bottleBlack;
    bottleImage.src=bottleUrl;dockBottle.querySelector('img').src=bottleUrl;
    scene.querySelectorAll('.tm-journey-color').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.color===value)));
  }
  scene.querySelectorAll('.tm-journey-color').forEach(button=>on(button,'click',()=>color(button.dataset.color)));
  on(window,'scroll',schedule,{passive:true});
  on(window,'resize',()=>{if(!geometry||document.documentElement.clientWidth!==geometry.width)measure();else schedule();},{passive:true});
  on(window,'load',measure,{once:true});
  on(document,'visibilitychange',()=>{if(document.hidden){effect?.cancel();}else schedule();});
  document.fonts?.ready.then(()=>{if(!signal.aborted)measure();});
  const layoutObserver=new ResizeObserver(measure);
  [scene,dock,document.querySelector('#tkb-kits'),document.querySelector('.tb-scroll'),document.querySelector('.tm-site-chrome')].filter(Boolean).forEach(el=>layoutObserver.observe(el));
  applyPreference();
  on(document,'shopify:section:unload',e=>{if(!e.target.contains(scene))return;abort.abort();layoutObserver.disconnect();cancelAnimationFrame(frame);flight.remove();bottleFlight.remove();clip?.remove();document.body.classList.remove('tm-motion-enhanced','tm-motion-disabled');});
})();
